export default __webpack_public_path__ + "static/media/miguel-lopes-24.1137a463.jpg";